// Admin Sagas Index
import { all, fork } from "redux-saga/effects";

// Import all admin sagas
import {
  watchAdminLogin,
  watchAdminLogout,
  watchAdminRegister,
  watchAdminForgotPassword,
  watchAdminResetPassword,
} from "./adminAuthSaga";

import {
  watchGetAdminDashboardData,
  watchGetAdminAnalytics,
} from "./adminDashboardSaga";

import {
  watchGetAllUsers,
  watchGetUserById,
  watchCreateUser,
  watchUpdateUser,
  watchDeleteUser,
  watchBlockUser,
  watchUnblockUser,
  watchGetUserActivity,
} from "./adminUserManagementSaga";

import adminApiKeysManagementSaga from "./adminApiKeysManagementSaga";
import { watchSupportTickets } from "./adminSupportSaga";

// Root Admin Saga
export default function* adminRootSaga() {
  yield all([
    // Auth Sagas
    fork(watchAdminLogin),
    fork(watchAdminLogout),
    fork(watchAdminRegister),
    fork(watchAdminForgotPassword),
    fork(watchAdminResetPassword),
    
    // Dashboard Sagas
    fork(watchGetAdminDashboardData),
    fork(watchGetAdminAnalytics),
    
    // User Management Sagas
    fork(watchGetAllUsers),
    fork(watchGetUserById),
    fork(watchCreateUser),
    fork(watchUpdateUser),
    fork(watchDeleteUser),
    fork(watchBlockUser),
    fork(watchUnblockUser),
    fork(watchGetUserActivity),
    
    // API Keys Management Sagas
    fork(adminApiKeysManagementSaga),
    // Support Sagas
    fork(watchSupportTickets),
  ]);
}
